import React from 'react';
import { observer } from 'mobx-react';

import { Input, Button, Badge, Icon } from 'antd';

@observer
class FilterTopBar extends React.Component {
	render() {
		return (
		<div>
			<div className="top-search">
				<Input.Search
				placeholder="Cerca un immobile"
				style={{ width: '82%' }}
				onSearch={this.props.stateStore.activateSearchPanel}
				onFocus={this.props.stateStore.activateSearchPanel}
				onChange={this.props.onSearchChange}
				value={this.props.stateStore.filterValue}
				/>
				<Button onClick={this.props.stateStore.activateScreenshotPanel} className="screenshot-bt" shape="circle" icon="camera" />
			</div>

			<div className="switch-list">
				{/* <Badge count={487} overflowCount={9999} style={{ backgroundColor: '#fff', color: '#999', boxShadow: '0 0 0 1px #d9d9d9 inset' }}/> */} 
				<div className="numimmo"><span> {this.props.stateStore.filteredPOIS.length}</span> immobili</div>
				{ this.props.stateStore.filterPanelShowList ? 
					(<Button  onClick={this.props.stateStore.toggleFilterPanelList} size="small">nascondi lista <Icon type="eye-invisible"/></Button>)
					: (<Button  onClick={this.props.stateStore.toggleFilterPanelList} size="small">mostra lista <Icon type="eye"/></Button>)
				}
			</div>
		</div>
		);
	}
}

class ScreenshotTopBar extends React.Component {
	render() {
		return (
		<div className="top-search">
			<Button className="back-bt" shape="circle" icon="arrow-left" onClick={this.props.stateStore.activateFilterPanel} />  
			<Button className="istantanea-bt" type="primary" shape="round" icon="picture" size="default">Scatta istantanea</Button>
		</div>
		);
	}
}

@observer
class SearchTopBar extends React.Component {
	constructor(props) {
		super(props);
		this.searchRef = React.createRef();
	}

	componentDidMount() {
		try {
			this.searchRef.current.focus();
		} catch(err){
			console.error(err);
		}
	}

	render() {
		return (
		<div className="top-search">
			<Input.Search
			placeholder="Cerca un immobile"
			style={{ width: '82%' }}
			onChange={this.props.onSearchChange}
			value={this.props.stateStore.filterValue}
			ref={this.searchRef}
			/>
			<Button className="close-bt" shape="circle" icon="close" onClick={this.props.stateStore.activateFilterPanel} />
		</div>
		);
	}
}

export { FilterTopBar, ScreenshotTopBar, SearchTopBar };
